var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 62,
    viewBox: "0 0 71 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70.62 0.1875H9.13281V61.125H70.62V0.1875Z",
    fill: "url(#paint0_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.6614 0.1875H26.2358V43.029H70.6614V0.1875Z",
    fill: "url(#paint1_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.6632 20.6289H20.0854V21.4433H34.6632V20.6289Z",
    fill: "url(#paint2_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.6632 15.7852H20.0854V16.5996H34.6632V15.7852Z",
    fill: "url(#paint3_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.9886 10.9375H20.0889V11.7519H27.9886V10.9375Z",
    fill: "url(#paint4_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.3996 10.9375H15.6079V11.7519H17.3996V10.9375Z",
    fill: "url(#paint5_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.3996 15.7852H15.6079V16.5996H17.3996V15.7852Z",
    fill: "url(#paint6_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.3996 20.6289H15.6079V21.4433H17.3996V20.6289Z",
    fill: "url(#paint7_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.3996 25.4336H15.6079V26.248H17.3996V25.4336Z",
    fill: "url(#paint8_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.3996 30.2812H15.6079V31.0956H17.3996V30.2812Z",
    fill: "url(#paint9_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.3996 35.0859H15.6079V35.9003H17.3996V35.0859Z",
    fill: "url(#paint10_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.3996 39.9297H15.6079V40.7441H17.3996V39.9297Z",
    fill: "url(#paint11_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.3996 44.7734H15.6079V45.5878H17.3996V44.7734Z",
    fill: "url(#paint12_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17.3996 49.5781H15.6079V50.3925H17.3996V49.5781Z",
    fill: "url(#paint13_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M62.5589 35.0859H37.7197V35.9003H62.5589V35.0859Z",
    fill: "url(#paint14_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.9483 35.0859H20.0854V35.9003H34.9483V35.0859Z",
    fill: "url(#paint15_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M64.9218 39.9297H43.7881V40.7441H64.9218V39.9297Z",
    fill: "url(#paint16_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M41.0599 39.9297H27.9888V40.7441H41.0599V39.9297Z",
    fill: "url(#paint17_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M56.7371 44.7734H27.9888V45.5878H56.7371V44.7734Z",
    fill: "url(#paint18_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M47.7765 49.5781H35.8862V50.3925H47.7765V49.5781Z",
    fill: "url(#paint19_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M42.8917 25.4336H29.2505V26.248H42.8917V25.4336Z",
    fill: "url(#paint20_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M42.8917 30.2812H29.2505V31.0956H42.8917V30.2812Z",
    fill: "url(#paint21_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M17.0732 31.2149C14.2406 31.2101 11.4728 32.0618 9.13281 33.6581V38.178C10.5549 36.6066 12.4113 35.4925 14.4669 34.9767C16.5225 34.4609 18.685 34.5667 20.6805 35.2805C22.676 35.9944 24.4148 37.2842 25.6768 38.9868C26.9388 40.6895 27.6673 42.7282 27.77 44.8451C27.8727 46.9619 27.345 49.0617 26.2538 50.8785C25.1625 52.6953 23.5567 54.1474 21.6397 55.0511C19.7227 55.9548 17.5806 56.2693 15.4847 55.955C13.3888 55.6406 11.4333 54.7114 9.86577 53.2851L9.13281 52.5522V57.0721C10.9633 58.3023 13.0564 59.0869 15.2446 59.3632C17.4327 59.6394 19.6551 59.3996 21.734 58.6629C23.8128 57.9262 25.6903 56.7131 27.2163 55.1207C28.7422 53.5283 29.8742 51.6008 30.5217 49.4925C31.1691 47.3842 31.314 45.1535 30.9448 42.9792C30.5756 40.8048 29.7025 38.747 28.3954 36.9706C27.0883 35.1941 25.3835 33.7483 23.4175 32.7488C21.4514 31.7494 19.2787 31.2241 17.0732 31.2149Z",
    fill: "url(#paint22_linear_9618_30098)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M6.10911 51.3635L0.0625 57.4102L1.7901 59.1378L7.83672 53.0911L6.10911 51.3635Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M15.8957 55.6478C22.7548 55.6478 28.3153 50.0874 28.3153 43.2282C28.3153 36.369 22.7548 30.8086 15.8957 30.8086C9.03652 30.8086 3.47607 36.369 3.47607 43.2282C3.47607 50.0874 9.03652 55.6478 15.8957 55.6478Z",
    fill: "url(#paint23_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M21.7589 48.4805H14.5107V50.9237H21.7589V48.4805Z",
    fill: "url(#paint24_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M21.7589 40.8242H14.5107V43.2674H21.7589V40.8242Z",
    fill: "url(#paint25_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M21.4331 33.1289H14.5107V35.5721H21.4331V33.1289Z",
    fill: "url(#paint26_linear_9618_30098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.2,
    d: "M17.7281 30.9297C14.1961 31.047 10.8214 32.419 8.20956 34.7995C5.59768 37.18 3.9195 40.4133 3.47607 43.9194C3.61278 46.3745 4.47517 48.7337 5.95398 50.6982C7.43279 52.6627 9.46147 54.144 11.783 54.9545C10.4952 54.1498 9.38381 53.0925 8.51598 51.8463C7.64815 50.6002 7.04186 49.1911 6.73371 47.7042C6.42555 46.2172 6.42193 44.6833 6.72306 43.1949C7.02419 41.7065 7.62382 40.2946 8.48575 39.0444C9.34768 37.7941 10.454 36.7316 11.738 35.9208C13.022 35.11 14.457 34.5679 15.9563 34.327C17.4556 34.0862 18.9882 34.1517 20.4615 34.5196C21.9348 34.8875 23.3182 35.5502 24.5283 36.4676C25.9392 37.4222 27.1099 38.6905 27.9488 40.1731C27.3336 37.8028 26.038 35.6645 24.2217 34.0219C22.4055 32.3793 20.1481 31.3044 17.7281 30.9297Z",
    fill: "#091E42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M15.8941 56.8683C13.1962 56.8683 10.5588 56.0683 8.31549 54.5694C6.07221 53.0705 4.32378 50.94 3.29131 48.4474C2.25884 45.9548 1.9887 43.212 2.51505 40.5659C3.0414 37.9197 4.3406 35.4891 6.24835 33.5814C8.15611 31.6736 10.5867 30.3744 13.2329 29.8481C15.879 29.3217 18.6218 29.5918 21.1144 30.6243C23.607 31.6568 25.7375 33.4052 27.2364 35.6485C28.7353 37.8918 29.5353 40.5292 29.5353 43.2271C29.5353 46.845 28.0982 50.3147 25.5399 52.8729C22.9817 55.4312 19.512 56.8683 15.8941 56.8683ZM15.8941 32.0291C13.6794 32.0291 11.5144 32.6859 9.67286 33.9163C7.83136 35.1468 6.39608 36.8957 5.54853 38.9419C4.70098 40.988 4.47923 43.2396 4.9113 45.4118C5.34338 47.584 6.40989 49.5793 7.97596 51.1453C9.54202 52.7114 11.5373 53.7779 13.7095 54.21C15.8817 54.6421 18.1333 54.4203 20.1794 53.5728C22.2256 52.7252 23.9745 51.2899 25.2049 49.4484C26.4354 47.6069 27.0921 45.4419 27.0921 43.2271C27.0921 40.2573 25.9124 37.409 23.8123 35.309C21.7123 33.2089 18.864 32.0291 15.8941 32.0291Z",
    fill: "#0065FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9618_30098",
    x1: 9.33009,
    y1: 26.3947,
    x2: 70.464,
    y2: 47.3753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9618_30098",
    x1: 26.3784,
    y1: 18.6122,
    x2: 70.2887,
    y2: 34.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9618_30098",
    x1: 20.0854,
    y1: 21.0361,
    x2: 34.6632,
    y2: 21.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9618_30098",
    x1: 20.0854,
    y1: 16.1924,
    x2: 34.6632,
    y2: 16.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9618_30098",
    x1: 20.0889,
    y1: 11.3447,
    x2: 27.9886,
    y2: 11.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9618_30098",
    x1: 15.6079,
    y1: 11.3447,
    x2: 17.3996,
    y2: 11.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9618_30098",
    x1: 15.6079,
    y1: 16.1924,
    x2: 17.3996,
    y2: 16.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9618_30098",
    x1: 15.6079,
    y1: 21.0361,
    x2: 17.3996,
    y2: 21.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9618_30098",
    x1: 15.6079,
    y1: 25.8408,
    x2: 17.3996,
    y2: 25.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9618_30098",
    x1: 15.6079,
    y1: 30.6884,
    x2: 17.3996,
    y2: 30.6884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9618_30098",
    x1: 15.6079,
    y1: 35.4931,
    x2: 17.3996,
    y2: 35.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9618_30098",
    x1: 15.6079,
    y1: 40.3369,
    x2: 17.3996,
    y2: 40.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9618_30098",
    x1: 15.6079,
    y1: 45.1806,
    x2: 17.3996,
    y2: 45.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9618_30098",
    x1: 15.6079,
    y1: 49.9853,
    x2: 17.3996,
    y2: 49.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9618_30098",
    x1: 37.7197,
    y1: 35.4931,
    x2: 62.5589,
    y2: 35.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9618_30098",
    x1: 20.0854,
    y1: 35.4931,
    x2: 34.9483,
    y2: 35.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9618_30098",
    x1: 43.7881,
    y1: 40.3369,
    x2: 64.9218,
    y2: 40.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9618_30098",
    x1: 27.9888,
    y1: 40.3369,
    x2: 41.0599,
    y2: 40.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9618_30098",
    x1: 27.9888,
    y1: 45.1806,
    x2: 56.7371,
    y2: 45.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9618_30098",
    x1: 35.8862,
    y1: 49.9853,
    x2: 47.7765,
    y2: 49.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9618_30098",
    x1: 29.2505,
    y1: 25.8408,
    x2: 42.8917,
    y2: 25.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9618_30098",
    x1: 29.2505,
    y1: 30.6884,
    x2: 42.8917,
    y2: 30.6884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9618_30098",
    x1: 9.20343,
    y1: 43.3684,
    x2: 32.0617,
    y2: 49.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9618_30098",
    x1: 3.55577,
    y1: 41.4911,
    x2: 28.2987,
    y2: 49.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9618_30098",
    x1: 14.5107,
    y1: 49.7021,
    x2: 21.7589,
    y2: 49.7021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9618_30098",
    x1: 14.5107,
    y1: 42.0458,
    x2: 21.7589,
    y2: 42.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9618_30098",
    x1: 14.5107,
    y1: 34.3505,
    x2: 21.4331,
    y2: 34.3505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContact);
export default __webpack_public_path__ + "static/media/noContact.ede8c80f7eb6d52ca8c48efb266cfcb6.svg";
export { ForwardRef as ReactComponent };